import nullsToUndefined from "@workspace/nextjs_utils/src/nullsToUndefined";
import getClientSubscriptionId from "./getClientSubscriptionId";

const parseMessage = (receivedData: string) => {
  try {
    const parsedMessage = nullsToUndefined(JSON.parse(receivedData));
    const opId =
      parsedMessage?.id ||
      parsedMessage?.eventData?.id ||
      getClientSubscriptionId(parsedMessage) ||
      parsedMessage?.eventData?.data?.loyaltyPublicMyStatusUpdated
        ?.clientSubscriptionId ||
      parsedMessage?.eventData?.data?.loyaltyPublicMyTiersUpdated
        ?.clientSubscriptionId ||
      parsedMessage?.eventData?.data?.loyaltyPublicMyMilestonesUpdated
        ?.clientSubscriptionId ||
      parsedMessage?.eventData?.data?.kycStatus?.clientSubscriptionId;
    return { parsedMessage, opId };
  } catch (error) {
    throw new Error(`Message must be JSON-parseable. Got: ${receivedData}`);
  }
};

export default parseMessage;
